import { Component, OnInit } from '@angular/core';
import { getCurrentUser } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss']
})
export class ForbiddenComponent implements OnInit {

  title: string = "Forbidden"
  isLoged = false

  constructor(private helpers: HelpersService) {
    this.helpers.setTitle("403 " + this.title)
  }

  ngOnInit(): void {
    try {
      this.isLoged = getCurrentUser().usuario_aplicativo ? true : false
    } catch (error) {
      this.isLoged = false
    }
  }

  goBack() {
    window.history.back()
  }
}
